import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Box, Center, CloseButton, Flex, Image, Loader, Text, UnstyledButton } from "@mantine/core";
import { useHover } from "@mantine/hooks";
import { downloadUrl } from "../../utils/download.js";
import { isImageMimeType } from "@project/common";
const wrapperStyle = {
    position: "relative",
    width: 200,
};
const closeBtnStyle = {
    zIndex: 1,
    transition: "opacity 150ms ease",
    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.3)",
    borderRadius: "50%",
};
const cardStyle = {
    border: "2px solid light-dark(black, white)",
    borderRadius: "var(--mantine-radius-md)",
    overflow: "hidden",
    minHeight: 120,
};
function getExtension(name) {
    const ext = name.split(".");
    if (ext.length > 1) {
        return ext.at(-1)?.toLowerCase() ?? "";
    }
    return "";
}
function formatFileSize(bytes) {
    if (bytes < 1024)
        return `${bytes} B`;
    if (bytes < 1024 * 1024)
        return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
function getName(attachment) {
    if ("name" in attachment)
        return attachment.name;
    if ("file" in attachment)
        return attachment.file.name;
    return "";
}
const Preview = ({ attachment }) => {
    if (!isImageMimeType(attachment.type)) {
        return;
    }
    return (_jsx(Image, { src: `/api/assistant/attachments/${attachment.id}/thumbnail`, alt: attachment.name, w: 80, fit: "cover", height: 120 }));
};
export const ChatAttachment = ({ attachment, onDelete }) => {
    const { hovered, ref } = useHover();
    const fileName = getName(attachment);
    const ext = getExtension(fileName);
    const isPending = "file" in attachment;
    const handleDownload = ({ name, id }) => {
        const url = `/api/assistant/attachments/${id}`;
        downloadUrl(url, name);
    };
    const card = (_jsxs(Box, { ref: ref, style: wrapperStyle, children: [_jsxs(Flex, { style: cardStyle, bg: "light-dark(white, var(--mantine-color-dark-7))", children: [_jsx(Flex, { direction: "column", flex: 1, p: "xs", justify: "space-between", children: isPending
                            ? (_jsx(Center, { flex: 1, children: _jsx(Loader, { size: "sm" }) }))
                            : (_jsxs(_Fragment, { children: [_jsx(Box, { children: _jsx(Text, { size: "xs", fw: 500, lineClamp: 2, style: { wordBreak: "break-all" }, children: fileName }) }), "size" in attachment && (_jsx(Text, { size: "10px", c: "dimmed", children: formatFileSize(attachment.size) })), ext && (_jsx(Badge, { size: "sm", variant: "light", color: "gray", mt: 4, children: ext.toUpperCase() }))] })) }), !isPending && (_jsx(Preview, { attachment: attachment }))] }), onDelete && (_jsx(CloseButton, { size: "md", variant: "default", bg: "light-dark(white, var(--mantine-color-dark-6))", pos: "absolute", top: -10, right: -10, style: { ...closeBtnStyle, opacity: hovered ? 1 : 0 }, onClick: (e) => {
                    e.stopPropagation();
                    onDelete(attachment.id);
                } }))] }));
    if ("type" in attachment) {
        return (_jsx(UnstyledButton, { component: "span", onClick: () => { handleDownload(attachment); }, children: card }));
    }
    return card;
};
